import { render, staticRenderFns } from "./OfferCategoryDetail.vue?vue&type=template&id=4e874050&scoped=true&"
import script from "./OfferCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./OfferCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=4e874050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e874050",
  null
  
)

export default component.exports